<template>
<div class="panel panel-clinic">

    <div class="panel-heading collapsed" href="#form_gdpr" data-toggle="collapse">

        <div class="arrow-down"></div>

        <h2 class="panel-title">GDPR</h2>

    </div>

    <div id="form_gdpr" class="panel-collapse collapse">

        <div class="panel-body">

          <div class="form-horizontal">
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showForced="false"
              :showDate="false"
              :showComment="true"
              type="checkbox_newsletter_opt_out"
              layout="checkBox"
              title="Massören vill ej ta emot utskick">
            </row-meta>
          </div>

          <div style="margin-bottom:40px;" v-if="meta.select_status.value === '1' || meta.select_status.value === null || meta.select_status.value === '3' || meta.select_status.value === '6' || meta.select_status.value === '7'">
            <h2>Ställ in att prospectet inte vill bli kontaktat (opt out)</h2>
            <p>Använd detta alternativ för partners som hört av sig och inte vill bli kontaktade mer.</p>
            <p>Status blir: <b>Avslutat prospect</b></p>
            <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="clinic.gdpr_prospect_opt_out_at">Prospectet vill inte bli kontaktad sedan: <b>{{ clinic.gdpr_prospect_opt_out_at }}</b></div>
            <button class="btn btn-danger" @click="prospectOptOut()" :disabled="prospectOptOut_submitted">Prospectet vill inte bli kontaktat</button>
          </div>

          <div style="margin-bottom:40px;" v-if="meta.select_status.value === '1' || meta.select_status.value === null || meta.select_status.value === '3' || meta.select_status.value === '6' || meta.select_status.value === '7'">
              <h2>Radera inaktivt prospect</h2>
              <p>Detta alternativ används när prospectet varit inaktivt i 18 månader. Loggen behålls för partnern. Görs i huvudsak automatiskt.</p>
              <p>Status blir: <b>Inaktivt prospect</b></p>
              <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="clinic.gdpr_prospect_inactive_at">Prospectet blev raderat: <b>{{ clinic.gdpr_prospect_inactive_at }}</b></div>
              <button class="btn btn-danger" @click="prospectInactive()" :disabled="prospectInactive_submitted">Radera pospectet</button>
          </div>

          <div style="margin-bottom:40px;" v-if="meta.select_status.value === '4'">
            <h2>Radering av partner efter uppsägning</h2>
            <p>Detta alternativ används för att radera en partner två år efter avslutat avtal. Görs i huvudsak automatiskt.</p>
            <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="clinic.gdpr_disconnected_2_year_at">Partnern blev raderad: <b>{{ clinic.gdpr_disconnected_2_year_at }}</b></div>
            <button class="btn btn-danger" @click="disconnectedDeleteTwoYears()" :disabled="disconnectedDeleteTwoYears_submitted">Radera partner</button>
          </div>

          <div v-if="meta.select_status.value === '4'">
            <h2>Radering av partner - resterande data</h2>
            <p>Detta alternativ används när 7 år gått efter uppsägning och partnern inte längre behöver finnas kvar av bokföringsskäl. Görs i huvudsak automatiskt.</p>
            <div style="display:inline-block; margin-bottom:12px; font-size:16px;" class="text-danger" v-if="clinic.gdpr_disconnected_7_year_at">Partnern blev raderad: <b>{{ clinic.gdpr_disconnected_7_year_at }}</b></div>
            <button class="btn btn-danger" @click="disconnectedDeleteSevenYears()" :disabled="disconnectedDeleteSevenYears_submitted">Radera resterande data</button>
          </div>

        </div>

    </div>

</div>
</template>

<script>

import axios from 'axios'
import mixin from './mixin'

export default {

    mixins: [mixin],

    props: {

        clinic: {
            required: true
        },

        meta: {
            required: true
        }

    },

    data () {
        return {
            prospectOptOut_submitted: false,
            prospectInactive_submitted: false,
            disconnectedDeleteTwoYears_submitted: false,
            disconnectedDeleteSevenYears_submitted: false
        }
    },

    methods: {
        prospectOptOut () {
            if (this.prospectOptOut_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för prospectet?')) {
                return
            }

            this.prospectOptOut_submitted = true

            axios.post(
                '/clinics/' + this.clinic.id + '/gdpr/prospectOptOut'
            )
                .then(response => {
                    console.log('prospectOptOut')
                    console.log(response.data)

                    bus.$emit('notify', 'Massören är opt outad.')
                    bus.$emit('refresh-data')
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        prospectInactive () {
            if (this.prospectInactive_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för prospectet?')) {
                return
            }

            this.prospectInactive_submitted = true

            axios.post(
                '/clinics/' + this.clinic.id + '/gdpr/prospectInactive'
            )
                .then(response => {
                    console.log('prospectInactive')
                    console.log(response.data)

                    bus.$emit('notify', 'Massören är raderad.')
                    bus.$emit('refresh-data')
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        disconnectedDeleteTwoYears () {
            if (this.disconnectedDeleteTwoYears_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för massören?')) {
                return
            }

            this.disconnectedDeleteTwoYears_submitted = true

            axios.post(
                '/clinics/' + this.clinic.id + '/gdpr/deleteDisconnectedData',
                { years: '2' }
            )
                .then(response => {
                    console.log('deleteDisconnectedData')
                    console.log(response.data)

                    bus.$emit('notify', 'Massören är raderad.')
                    bus.$emit('refresh-data')
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        disconnectedDeleteSevenYears () {
            if (this.disconnectedDeleteSevenYears_submitted) {
                return
            }

            if (!confirm('Vill du verkligen radera all information för massören?')) {
                return
            }

            this.disconnectedDeleteSevenYears_submitted = true

            axios.post(
                '/clinics/' + this.clinic.id + '/gdpr/deleteDisconnectedData',
                { years: '7' }
            )
                .then(response => {
                    console.log('deleteDisconnectedData')
                    console.log(response.data)

                    bus.$emit('notify', 'Massören är raderad.')
                    bus.$emit('refresh-data')
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
